<template>
    <el-row type="flex" justify="center" class="p-5">
        <el-col :span="2">
            </el-col>
            <el-col :span="24" class="head_title_zone">
                <span class="head_title">{{ currentRoute }}</span>
            </el-col>
            <el-col :span="2">
            </el-col>
    </el-row>
  </template>

<script>
export default {
  computed: {
    currentRoute () {
      switch (this.$route.name) {
        case 'TrackCodeList':
          return 'Барааны жагсаалт'
        case 'TrackCodeHistory':
          return 'Барааны жагсаалтын түүх'
        case 'Profile':
          return 'Профайл'
        case 'Home':
          return 'Трак код бүртгэх'
        case 'MeasuringOut':
          return 'Бараа олгох'
        case 'ConfigPage':
          return 'Тохиргоо'
        case 'Cargo':
        case 'CargoPage':
          return 'Ачаа'
        case 'PackagePage':
          return 'Багц'
        default:
          return ''
      }
    }
  }
}
</script>
<style>
.text_center{
    text-align: center;
}
</style>
